import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * MasterUnlockGate — runs on every route mount.
 * Reads ?unlock=<token> from the current URL, validates it against a
 * master-gated backend endpoint, stores it in localStorage on success,
 * strips the query string immediately so nothing sticks in the address
 * bar. This is the sole master-unlock surface — there is no /toaster
 * page and no visible login form.
 */
export default function MasterUnlockGate() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const candidate = params.get("unlock");
    if (!candidate) return;

    // Strip the query string IMMEDIATELY — before the validation call
    // returns — so the token never lingers in the URL bar even for a
    // network round-trip.
    params.delete("unlock");
    const cleanSearch = params.toString();
    const cleanUrl =
      location.pathname + (cleanSearch ? `?${cleanSearch}` : "") + location.hash;
    window.history.replaceState({}, "", cleanUrl);

    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/sage/admin/status`, {
          headers: { Authorization: `Bearer ${candidate}` },
        });
        if (!r.ok) {
          toast.error("Token rejected.");
          return;
        }
        localStorage.setItem("sage_master_token", candidate);
        toast.success("Master unlocked.");
        // Small nav-noop to force any RequireMaster wrappers to re-check
        navigate(location.pathname + (cleanSearch ? `?${cleanSearch}` : ""), {
          replace: true,
        });
      } catch (e) {
        toast.error(`Unlock failed: ${e.message}`);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return null;
}
